import * as React from 'react';
import { EEstimationTargets, EMyHomeEstimationTargets } from '@cian/valuation-main-filters-widget';
import { useSelector } from 'react-redux';
import { selectEstimationTarget } from '../../../selectors/filters';
import { useAppDispatch } from 'shared/hooks';
import { submitFlatData, submitSuburbanData } from '../../../thunks';
import { selectsRedirectLink } from '../../../selectors/filters/selectsRedirectLink';
import { navigateToPage } from '@cian/valuation-utils-component';
import { trackAddNewCard } from '../analytics';
import { deleteErrorMessage } from 'shared/slices';

export const useSubmitClickHandler = () => {
  const dispatch = useAppDispatch();

  const estimationTarget: EEstimationTargets = useSelector(selectEstimationTarget);
  const redirectLink = useSelector(selectsRedirectLink);

  const isSuburban = [EEstimationTargets.house, EEstimationTargets.land].includes(estimationTarget);

  const submitFlatClickHandler = React.useCallback(() => {
    dispatch(submitFlatData());
  }, [dispatch]);

  const submitSuburbanClickHandler = React.useCallback(() => {
    dispatch(submitSuburbanData());
  }, [dispatch]);

  React.useEffect(() => {
    if (redirectLink) {
      navigateToPage(redirectLink);
    }
  }, [redirectLink]);

  return React.useCallback(() => {
    trackAddNewCard(estimationTarget as EMyHomeEstimationTargets);
    dispatch(deleteErrorMessage());

    if (isSuburban) {
      submitSuburbanClickHandler();

      return;
    }

    submitFlatClickHandler();

    return;
  }, [isSuburban, estimationTarget, submitFlatClickHandler, submitSuburbanClickHandler, dispatch]);
};
